/**
 * 共用的頻譜降採樣工具:把 AnalyserNode 的位元組頻譜降採樣成 `count` 個
 * 0..1 的音量值,供 landing 示範卡的波形視覺使用。
 *
 * 抽出此函式以消除 `use-pcm-stream.ts` 與 `use-mic-recorder.ts` 之間
 * 逐字重複的 bucket-averaging 迴圈(兩份必須同步維護的 DRY 風險)。
 */

/**
 * 讀取 `analyser` 目前的頻譜(寫入呼叫端提供、可重複使用的 `freqData`),
 * 將其降採樣成 `count` 個 0..1 的正規化音量值。
 *
 * 呼叫端負責配置 `freqData`(長度應為 `analyser.frequencyBinCount`)以避免
 * 每幀重新配置。
 */
export function downsampleFrequencyData(
  analyser: AnalyserNode,
  freqData: Uint8Array,
  count: number
): number[] {
  // getByteFrequencyData 的型別期待以 ArrayBuffer 為底的 Uint8Array;
  // 我們的 freqData 一律如此配置,這個 cast 只是滿足 lib.dom 的泛型。
  analyser.getByteFrequencyData(freqData as Uint8Array<ArrayBuffer>)
  const levels: number[] = []
  const bucketSize = freqData.length / count
  for (let i = 0; i < count; i++) {
    const startBin = Math.floor(i * bucketSize)
    const endBin = Math.max(startBin + 1, Math.floor((i + 1) * bucketSize))
    let sum = 0
    for (let bin = startBin; bin < endBin; bin++) sum += freqData[bin]
    levels.push(sum / (endBin - startBin) / 255)
  }
  return levels
}
